import type { Character } from "@/types";

export const characterList: Character[] = [
  {
    id: "char-1",
    name: "星野遥",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20determined%20young%20male%20space%20explorer%20in%20a%20flight%20suit%2C%20friendly%20smile%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-01&orientation=squarish",
    animeTitle: "星海启航",
    animeId: "anime-1",
    roleType: "主角",
    description:
      "来自边缘星球的少年探险家，性格乐观坚韧，是风信子号的舵手。",
    background:
      "星野遥在资源匮乏的边缘星球长大，从小听着外祖母讲述星际航海的故事。一次偶然的机会，他得到了一张古老星图，从此踏上寻找失落文明的旅程。他最大的优点是不轻言放弃，最大的缺点则是太容易把别人的事揽在自己身上。",
    relations: [
      { name: "莉亚", relation: "船上机械师 / 最佳搭档" },
      { name: "老葛", relation: "船长 / 亦师亦友" },
      { name: "星野绫", relation: "外祖母 / 故事启蒙者" },
    ],
    quotes: ["「星图不会说谎，迷路的只是我们而已。」", "「只要还能看见星星，就还没到终点。」"],
    tags: ["热血", "成长", "队长型"],
    views: 42000,
    publishTime: "2025-09-18",
  },
  {
    id: "char-2",
    name: "莉亚",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20female%20engineer%20with%20goggles%20and%20short%20teal%20hair%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-02&orientation=squarish",
    animeTitle: "星海启航",
    animeId: "anime-1",
    roleType: "主角",
    description: "风信子号的机械师，手脚麻利话不多，却是全船最可靠的人。",
    background:
      "莉亚出身于著名的星际工程师世家，却因不愿继承家族事业而独自出走。她精通从反应堆到咖啡机的一切机械，唯独不擅长表达情绪。她与星野遥的相处，是整个旅程最动人的部分之一。",
    relations: [
      { name: "星野遥", relation: "同伴 / 最佳搭档" },
      { name: "老葛", relation: "船长 / 雇主" },
      { name: "莉亚父亲", relation: "工程师世家家长 / 心结" },
    ],
    quotes: ["「坏掉的机器我不会修，坏掉的人我更不会。」"],
    tags: ["高冷", "技术宅", "可靠"],
    views: 38000,
    publishTime: "2025-09-18",
  },
  {
    id: "char-3",
    name: "艾莉娅",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20noble%20female%20knight%20with%20white%20feathered%20wings%20and%20silver%20armor%2C%20calm%20expression%2C%20clean%20minimal%20light%20background%2C%20modern%20fantasy%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-03&orientation=squarish",
    animeTitle: "苍穹之翼",
    animeId: "anime-2",
    roleType: "主角",
    description: "最后一代苍穹骑士，背负守护天空之城的使命。",
    background:
      "艾莉娅自幼在天空之城接受骑士训练，是同龄人中最出色的羽翼战士。她相信规则与秩序，却在面对风暴时逐渐意识到，真正的守护不是服从命令，而是遵从内心。",
    relations: [
      { name: "凯尔文", relation: "教官 / 引路人" },
      { name: "天空议会", relation: "上级 / 立场对立" },
    ],
    quotes: ["「翅膀不是用来服从的，是用来选择的。」"],
    tags: ["骑士", "正义", "成长"],
    views: 35000,
    publishTime: "2025-07-02",
  },
  {
    id: "char-4",
    name: "R-07",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cute%20humanoid%20robot%20child%20with%20a%20soft%20glowing%20orange%20chest%20core%2C%20gentle%20expression%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-04&orientation=squarish",
    animeTitle: "机械之心",
    animeId: "anime-3",
    roleType: "主角",
    description: "被遗弃的仿生机器人，执着地寻找“心”的意义。",
    background:
      "R-07 是旧时代遗留的仿生机器人，核心能量所剩无几。它不记得自己是谁制造的，却记得每个曾帮助过它的人。它相信，只要还记得那些温暖，就不算真正的机器。",
    relations: [
      { name: "阿哲", relation: "工程师 / 修复者" },
      { name: "旧工厂", relation: "出生地 / 记忆起点" },
    ],
    quotes: ["「如果记忆会被删除，那我记得的你，还算数吗？」"],
    tags: ["治愈", "机器人", "纯真"],
    views: 33000,
    publishTime: "2024-11-20",
  },
  {
    id: "char-5",
    name: "时野",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20thoughtful%20teenage%20boy%20holding%20an%20old%20pocket%20watch%2C%20soft%20determined%20look%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-05&orientation=squarish",
    animeTitle: "时空旅人",
    animeId: "anime-5",
    roleType: "主角",
    description: "拥有回溯时间怀表的高中生，为救人甘愿失去记忆。",
    background:
      "时野原本是个普通的高中生，直到那场事故夺走了他最重要的人。怀表给了他重来的机会，也给了他遗忘的代价。他一次次回到那个夏天，只为让结局不再一样。",
    relations: [
      { name: "夏织", relation: "重要之人 / 命运羁绊" },
      { name: "旧怀表", relation: "时间道具 / 代价来源" },
    ],
    quotes: ["「就算忘了你，我也会一次又一次地选择你。」"],
    tags: ["深情", "悬疑", "催泪"],
    views: 36000,
    publishTime: "2025-08-30",
  },
  {
    id: "char-6",
    name: "樱庭千夏",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20female%20samurai%20with%20a%20katana%20and%20pink%20kimono%2C%20resolute%20expression%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-06&orientation=squarish",
    animeTitle: "樱花剑姬",
    animeId: "anime-4",
    roleType: "主角",
    description: "以“樱姬”之名行走江湖的少女剑客，追查灭门真相。",
    background:
      "千夏是樱庭一族唯一的幸存者，自幼在樱花树下被剑客收养。她以花为誓，将复仇藏于心间，却在旅途中渐渐明白，剑的意义远不止于杀戮。",
    relations: [
      { name: "银发剑客", relation: "对手 / 身世关联" },
      { name: "收养剑客", relation: "养父 / 授业恩师" },
    ],
    quotes: ["「花开一季，剑sharp一次，都只为不辜负。」", "「我斩的不是人，是过去。」"],
    tags: ["剑客", "复仇", "坚强"],
    views: 31000,
    publishTime: "2024-04-12",
  },
  {
    id: "char-7",
    name: "蔻蔻",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20warm%20smiling%20young%20female%20baker%20in%20an%20apron%2C%20soft%20peach%20tones%2C%20clean%20minimal%20light%20background%2C%20healing%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-07&orientation=squarish",
    animeTitle: "甜梦烘焙屋",
    animeId: "anime-9",
    roleType: "主角",
    description: "深夜烘焙屋的店长，能读懂每位客人心里的事。",
    background:
      "蔻蔻曾是都市里行色匆匆的上班族，直到某个失眠的夜晚，她决定开一家只营业到深夜的烘焙屋。她相信，一块对的点心，能安放一颗漂泊的心。",
    relations: [
      { name: "小麦", relation: "学徒 / 搭档" },
      { name: "深夜客人", relation: "服务对象 / 故事来源" },
    ],
    quotes: ["「甜味会散，但被温柔对待过的感觉不会。」"],
    tags: ["治愈", "温柔", "美食"],
    views: 29000,
    publishTime: "2025-05-10",
  },
  {
    id: "char-8",
    name: "零",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20female%20cyberpunk%20hacker%20with%20neon%20teal%20highlights%20and%20a%20hoodie%2C%20confident%20look%2C%20clean%20minimal%20dark%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-08&orientation=squarish",
    animeTitle: "赛博都市 2030",
    animeId: "anime-12",
    roleType: "主角",
    description: "游走于数据洪流的地下黑客，代号“零”，寻找被抹去的记忆。",
    background:
      "在新港市，记忆由云端统一管理。代号“零”的少女发现自己的档案里空缺了一整年。为了夺回属于自己的过去，她潜入城市最森严的数据核心，也揭开了这座城市最深的秘密。",
    relations: [
      { name: "网络警察", relation: "追捕者 / 立场对立" },
      { name: "数据核心", relation: "目标 / 记忆线索" },
    ],
    quotes: ["「被删除的，不代表没发生过。」"],
    tags: ["黑客", "冷峻", "反叛"],
    views: 32000,
    publishTime: "2025-03-05",
  },
  {
    id: "char-9",
    name: "白狐",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20elegant%20white%20fox%20spirit%20in%20human%20form%20with%20flowing%20white%20hair%20and%20soft%20glow%2C%20clean%20minimal%20light%20background%2C%20modern%20fantasy%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-09&orientation=squarish",
    animeTitle: "灵狐物语",
    animeId: "anime-11",
    roleType: "配角",
    description: "守护神社千年的白狐灵，会化为人形，性子散漫却重情。",
    background:
      "白狐曾是神社的守护灵，随着信众离去而日渐虚弱。某个满月夜，它化作人形出现在守林少女千代面前。它嘴上说着只是路过，却默默陪她修补了整座神社。",
    relations: [
      { name: "千代", relation: "守林少女 / 羁绊" },
      { name: "古神社", relation: "守护对象 / 归属" },
    ],
    quotes: ["「我活了千年，才学会一件事——留下比离开难。」"],
    tags: ["神怪", "散漫", "深情"],
    views: 27000,
    publishTime: "2025-07-21",
  },
  {
    id: "char-10",
    name: "阿哲",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20weathered%20middle-aged%20male%20engineer%20with%20a%20gentle%20look%2C%20work%20overalls%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-10&orientation=squarish",
    animeTitle: "机械之心",
    animeId: "anime-3",
    roleType: "配角",
    description: "退役工程师，表面冷淡，实则最懂“修东西也是修自己”。",
    background:
      "阿哲曾是旧工厂的明星工程师，一场事故后他选择隐居废墟。遇到 R-07 后，他重新拾起工具，也慢慢面对自己一直回避的过去。",
    relations: [
      { name: "R-07", relation: "捡到的机器人 / 陪伴" },
      { name: "旧同事", relation: "旧日羁绊 / 未解心结" },
    ],
    quotes: ["「修好一台机器不难，难的是承认自己也想被修好。」"],
    tags: ["工程师", "沉默", "温情"],
    views: 24000,
    publishTime: "2024-11-20",
  },
  {
    id: "char-11",
    name: "岩川",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20rugged%20young%20male%20mountain%20hunter%20with%20fur%20cloak%20and%20a%20spear%2C%20determined%20look%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-11&orientation=squarish",
    animeTitle: "龙脊传说",
    animeId: "anime-8",
    roleType: "主角",
    description: "背负部族命运的猎人少年，攀登龙脊山的试炼者。",
    background:
      "岩川自幼在雪山部族长大，部族因水源枯竭而濒临消亡。他决定独自攀登传说中的龙脊山，为族人带回希望，也在风雪中直面自己内心的恐惧。",
    relations: [
      { name: "长老祁", relation: "部族长者 / 引路" },
      { name: "龙魂", relation: "山顶传说 / 目标" },
    ],
    quotes: ["「山不会让路，那我就把路踩出来。」"],
    tags: ["热血", "坚毅", "国漫"],
    views: 22000,
    publishTime: "2023-12-15",
  },
  {
    id: "char-12",
    name: "千代",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20gentle%20shrine%20maiden%20girl%20in%20a%20white%20and%20red%20robe%20with%20a%20quiet%20smile%2C%20clean%20minimal%20light%20background%2C%20modern%20anime%20character%20illustration%2C%20high%20detail&width=400&height=400&seq=char-avatar-12&orientation=squarish",
    animeTitle: "灵狐物语",
    animeId: "anime-11",
    roleType: "主角",
    description: "独自守护古神社的少女，温柔而固执。",
    background:
      "随着村子日渐凋零，千代成了神社唯一的守林人。她把每一盏灯笼都当作还在等待的人。遇见白狐之后，她第一次觉得，守护这件事不再孤单。",
    relations: [
      { name: "白狐", relation: "同伴 / 羁绊" },
      { name: "离乡村民", relation: "旧日邻里 / 牵挂" },
    ],
    quotes: ["「只要还有一盏灯亮着，就还有人愿意回来。」"],
    tags: ["巫女", "温柔", "守护"],
    views: 21000,
    publishTime: "2025-07-21",
  },
];